export const ORIGINAL_VOICE_TICKET_AMOUNT = 10000
export const DISCOUNT_VOICE_TICKET_AMOUNT = 5000

export const PRODUCT_THUMBNAIL_IMAGE_SLOT_CNT = 8
